export const MetricLoaderCell = () => {
  return (
    <div className="h-full flex items-center px-2">
      <div className="animate-pulse flex-grow h-full flex items-center">
        <div className="h-2 w-2/5 bg-gray-2"></div>
      </div>
    </div>
  );
};
